import {Component, computed, inject, input, output} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {ApiErrorSnackbarService} from '../../services/api-error-snackbar.service';
import {InfoCardComponent} from '../info-card/info-card.component';

@Component({
  selector: 'app-error-card',
  imports: [
    MatButton,
    MatExpansionModule,
    InfoCardComponent
  ],
  templateUrl: './error-card.component.html',
  styleUrl: './error-card.component.scss'
})
export class ErrorCardComponent {
  private readonly errorService: ApiErrorSnackbarService = inject(ApiErrorSnackbarService);

  warningButtonText = input<string>();
  oopsError = input<any>();
  extendingText = input<string>();

  warningClicked = output<boolean>();

  errorMessage = computed(() => this.oopsError() ?
    this.errorService.getErrorMessage(this.oopsError())
    : 'Ops something went wrong');

  onWarningClick(): void {
    if (!this.warningButtonText()) {
      return;
    }
    this.warningClicked.emit(true);
  }
}
